import React, { useEffect, useState } from "react";
import ListLayout from "../common/ListLayout";
import AmenityCreateModal from "./CreateAmenityModal";
import { useGetAllApartmentAmenityQuery, useDeleteApartmentAmenityMutation, useCreateApartmentAmenityMutation } from '../../../store/api/apartment'
import ConfirmDeleteModal from "../common/DeleteModal";
import UpdateModal from './UpdateModal'
import SuccessModal from "../common/SuccessModal";
const List = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [deleteAmenity] = useDeleteApartmentAmenityMutation();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [count, setCount] = useState(0);
    const [filters, setFilters] = useState({});
    const [tableData, setTableData] = useState([]);
    const [message, setSuccessMessage] = useState("");
    const [messageType, setMessageType] = useState("success");
    const [isDeleting, setIsDeleting] = useState(false)
    const [deleteModalOpen, setDeleteModalOpen] = useState(false)
    const [selectAmenity, setSelectAmenity] = useState(null)

    const [isupdateModalopen, setIsupdateModalOpen] = useState(false)
    // const [apartmentId, setAparmentId] = useState(null)
    const [apartmentId, setApartmentId] = useState(null)
    console.log(apartmentId, "sssssssssssssss");

    const { data: ApartmentsData, refetch } = useGetAllApartmentAmenityQuery({
        page: currentPage,
        page_size: pageSize,
        ...filters,
    });


    const [aptdata, setAptdata] = useState([])

    useEffect(() => {
        if (ApartmentsData) {
            setTableData(ApartmentsData.results)
            setCount(ApartmentsData.count)
        }

    }, [ApartmentsData])

    const BASE_URL = process.env.REACT_APP_API_URL.replace("/api", "");
    
    const handleNotification = (message, type = "success") => {
        setSuccessMessage(message);
        setMessageType(type);
    };

    const tableHeaders = [
        { label: "Name", key: "name" },
        {
            label: "Logo",
            key: "logo",
            formatter: (value, row) => {
                // Handle missing or relative URLs
                const imageUrl = value
                    ? `${BASE_URL}${value.startsWith("/") ? value : `/${value}`}`
                    : "/placeholder.png"; // Optional placeholder

                return (
                    <img
                        src={imageUrl}
                        alt={row.name}
                        className="h-8 w-12 object-cover  border"
                        onError={(e) => (e.target.src = "/placeholder.png")}
                    />
                );
            },
        },
    ];


    const actionButtons = [
        // {
        //     icon: "MdOutlineRemoveRedEye",
        //     onClick: (row) => console.log(`View ${row.id}`),
        // },
        {
            icon: "MdOutlineModeEdit",
            onClick: (row) => {
                console.log(`View ${row.id}`)
                setApartmentId(row.id)
                setIsupdateModalOpen(true)
            },
        },
        {
            icon: "RiDeleteBinLine",
            onClick: (row) => {
                setSelectAmenity(row)
                setDeleteModalOpen(true)

            }
        }
    ];
    const handleConfirmDelete = async () => {
        if (!selectAmenity) return;
        setIsDeleting(true);
        try {
            await deleteAmenity(selectAmenity.id).unwrap();
            setDeleteModalOpen(false);
            setSelectAmenity(null);
            refetch();
        } catch (error) {
            console.error("Delete failed:", error);
            alert("Failed to delete Amenity.");
        } finally {
            setIsDeleting(false);
        }
    };


    return (
        <>
            <ListLayout
                title="Staff List"
                tableHeaders={tableHeaders}
                tableData={tableData}
                actionButtons={actionButtons}
                currentPage={currentPage}
                onAddNewButton={() => setIsModalOpen(true)}
                setCurrentPage={setCurrentPage}
                pageSize={pageSize}
                setPageSize={setPageSize}
                totalCount={count}
            />
            <AmenityCreateModal
                isOpen={isModalOpen}
                    onNotification={handleNotification}
                onClose={() => {
                    setIsModalOpen(false);
                    refetch(); // refresh list after modal is closed
                }}
            />
            <ConfirmDeleteModal
                isOpen={deleteModalOpen}
                onClose={() => setDeleteModalOpen(false)}
                onConfirm={handleConfirmDelete}
                itemName={selectAmenity?.name}
                isDeleting={isDeleting}
            />
            <UpdateModal
                isOpen={isupdateModalopen}
                ApartmentId={apartmentId}
                onNotification={handleNotification}
                onClose={() => { setIsupdateModalOpen(false) }}
            />
            <SuccessModal
                message={message}
                type={messageType}
                onClose={() => setSuccessMessage("")}
            />

        </>
    );
};

export default List;
